import { render } from "./BeneficiariesPage.vue?vue&type=template&id=3bf27212&ts=true"
import script from "./BeneficiariesPage.vue?vue&type=script&lang=ts"
export * from "./BeneficiariesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__